export function getDashboardProjectListBody({
  isTeamAdmin,
  teamCode,
  userId,
  userRole,
}: {
  isTeamAdmin: boolean;
  teamCode: string;
  userId: string;
  userRole: number;
}) {
  const pagination = { pageIndex: 0, pageSize: 1000 };
  if (isTeamAdmin || userRole === 1) {
    return { team_code: teamCode, ...pagination };
  }
  return { member_id: userId, ...pagination };
}
